<ambita-landregistry>
  <ambita-loading-indicator show="{ state == states.LOADING }"
                            loading-text="{ i18n.landRegistry.loadingLookup }"/>
  <div show="{ state == states.DONE_FAILED }">
    <span>{ error }</span>
  </div>
  <div show="{ state == states.DONE_SUCCESS }">
    <div class="ambita-landregistry__meta-header">
      <div class="ambita-landregistry__meta-header-sub-element">
        <span>Registreringsenhet: STATENS KARTVERK TINGLYSINGEN</span>
        <div>Registerenhet: { propertyKey }</div>
        <div if="{ item.eventStatus === 'historical' }">
          Historikk fra: { item.dateConverted.ddmmyyyy }
        </div>
      </div>
      <div class="ambita-landregistry__meta-header-sub-element ambita-absolute-align-bottom-right">
        <span if="{ item.landRegistryUpToDate.ddmmyyyy }">
          Oppdatert per: { item.landRegistryUpToDate.ddmmyyyy }
        </span>
        <span if="{ item.landRegistryUpToDate.ddmmyyyyHHmm }">
          Oppdatert per: { item.landRegistryUpToDate.ddmmyyyyHHmm }
        </span>
      </div>
    </div>

    <div class="il-system-messages__message-list il-system-messages-il-info" show="{ !purchaseAllowed }">
      <div class="il-system-messages__message-content">
        <i class="fas fa-info-circle il-system-messages__icon"></i>
        <p>Bestilling av pantebokkopi leveres nå digitalt, og kan lengre ikke bestilles fra denne siden. Om Infoland i ditt fagsystem ikke har andre bestillingsmuligheter for pantebokkopi, kan du benytte Infoland.no<p>
      </div>
    </div>

    <div each="{ part in item.parts }">
      <div>
        <h3 class="ambita-landregistry__parts-header ambita-report-h3">{ part.header }</h3>
        <div if="{ part.topText }" each="{ line in part.topText }"
             class="ambita-landregistry-details ambita-landregistry-paragraph">
          <span each="{ item in line.items }" class="{ getTextItemClasses(item) }">{ item.text }</span>
        </div>
      </div>
      <div each="{ level in part.levels }">
        <div if="{ item.gapi === 2 || sizeOfMap(level.rights) }">
          <h4 if="{ level.header }" class="ambita-landregistry__heading-rights ambita-report-h4">
            { level.header }:
          </h4>
          <div if="{ level.topText }" each="{ line in level.topText }"
               class="ambita-landregistry-details ambita-landregistry-paragraph">
            <span each="{ item in line.items }" class="{ getTextItemClasses(item) }">{ item.text }</span>
          </div>
          <ambita-landregistry-right knr="{ parent.knr }" each="{ right in level.rights }"/>
        </div>
      </div>
      <div if="{ part.bottomText }" each="{ line in part.bottomText }"
           class="ambita-landregistry-details ambita-landregistry-paragraph">
        <span each="{ item in line.items }" class="{ getTextItemClasses(item) }">{ item.text }</span>
      </div>
    </div>

    <div class="ambita-landregistry__meta-footer ambita-text-right">
      <span>Data uthentet: { dataFetchedAtTime }</span>
    </div>
  </div>

  <script>
    import '../common/loadingIndicator.tag';
    import './landRegistry.scss';
    import './landRegistryTranslations';
    import './landRegistryRight.tag';
    import { init } from './landRegistryController';

    init(this);
  </script>
</ambita-landregistry>
